import React, { FC } from 'react';
// The Label component renders a label with optional styling and a required asterisk (*).
// It takes optional props like `text`, `htmlFor`, `className`, `children`, `style`, and `required`.
// If the `required` prop is true, it adds a red asterisk next to the label text to indicate that the field is mandatory.


interface LabelProps {
  text?: string;
  htmlFor?: string; 
  className?: string; 
  children?: React.ReactNode;
  style?: React.CSSProperties;
  required?: boolean;
}

const Label: FC<LabelProps> = ({ htmlFor, className,children ,required}) => {
  return (
    <label htmlFor={htmlFor} className={ className }>
      {children}
      {required && <span style={{ color: "red", marginLeft: "2px" }}>*</span>}
    </label>
  );
};

export default Label;
